import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import PageLayout from '../../layouts/PageLayout';
import SplitLayout from '../../layouts/SplitLayout';
import { setDates, setEquipment } from './actions';
import FormView from './containers/FormView';
import DataTable from './containers/DataTable';
import { routerProps } from '../../propTypes';

/* eslint-disable react/no-unused-prop-types */
const propTypes = exact({
  setDatesAction: PropTypes.func.isRequired,
  setEquipmentAction: PropTypes.func.isRequired,

  ...routerProps,
});
/* eslint-enable react/no-unused-prop-types */

const EquipmentUsageReport = (props) => {
  return (
    <PageLayout
      title="Equipment Usage Report"
      render={() => {
        return (
          <SplitLayout
            leftSize={2}
            leftRender={() => {
              return (
                <FormView />
              );
            }}
            rightSize={10}
            rightRender={() => {
              return (
                <DataTable />
              );
            }}
          />
        );
      }}
    />
  );
};

EquipmentUsageReport.propTypes = propTypes;


const mapDispatchToProps = {
  setDatesAction: setDates,
  setEquipmentAction: setEquipment,
};

EquipmentUsageReport.propTypes = propTypes;

const withRedux = connect(null, mapDispatchToProps);

const withInit = lifecycle({
  componentWillMount() {
    const { setDatesAction, setEquipmentAction } = this.props;
    setDatesAction(null, null);
    setEquipmentAction(null);
  },
});

const enhance = compose(
  withRedux,
  withInit,
);

export default enhance(EquipmentUsageReport);
